type BenefitIcon = {
  tr_label: string;
  icon: string | null;
};

type BenefitsProps = {
  benefits_icons: BenefitIcon[];
};

export const Benefits = ({ benefits_icons }: BenefitsProps) => (
  <div className="product-benefits content-wide">
    {benefits_icons.map((benefit, idx) => (
      <div className="benefit-item" key={`${benefit.tr_label}-${idx}`}>
        {benefit.icon && (
          <div className="benefit-icon">
            <img src={benefit.icon} alt={benefit.tr_label} />
          </div>
        )}
        <span className="benefit-title">{benefit.tr_label}</span>
      </div>
    ))}
  </div>
);
